import InteractionLogDialog  from './InteractionLogDialog';

export default InteractionLogDialog ;